/** @jsx jsx */
import { jsx, Flex, Link } from 'theme-ui'
import { any } from 'prop-types'
import { socialData } from './socialData'

const SocialSection = ({ socialLinks }) => {
  return (
    <Flex sx={{ mt: 7 }}>
      {socialLinks &&
        socialLinks.map(({ id, socialPlatform, link }) => {
          const SocialComponent = socialData[socialPlatform].component
          return (
            <Link
              key={id}
              sx={{ m: 2 }}
              href={link}
              rel="noreferrer"
              target="_blank"
            >
              <SocialComponent />
            </Link>
          )
        })}
    </Flex>
  )
}

SocialSection.propTypes = {
  socialLinks: any,
}

export default SocialSection
